import { createTenantManagementRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';

const request = createTenantManagementRequest();

export interface AuthorizedResourceAction {
  name: string;
  description?: string;
}

export interface AuthorizedResource {
  effect?: string;
  code: string;
  type?: string;
  condition?: unknown;
  description?: string | null;
  actions?: string[];
  apiIdentifier?: string | null;
  namespaceId?: number | null;
}

export async function getMyAuthorizedResources(
  appId: string,
  options?: ApiRequestOptions,
) {
  return request<AuthorizedResource[]>(
    '/bff/permission/me/authorized-resources',
    {
      method: 'GET',
      params: { appId },
      ...(options || {}),
    },
  );
}
